import { Component, OnInit } from '@angular/core';
import { GlobalConstants } from 'src/app/common/global-constants';
import { RegisterUserVm } from 'src/app/services/property-matrix/models';
import { HttpStatusCode } from '@angular/common/http';
import { GlobalMethods } from 'src/app/common/global-methods';
import { AuthenticateService } from 'src/app/services/property-matrix/services';
import { Router } from '@angular/router';
import { PropertyMatrixSharedService } from 'src/app/property-matrix-shared.service';

@Component({
  selector: 'app-register-valuer',
  templateUrl: './register-valuer.component.html',
  styleUrls: ['./register-valuer.component.scss', '../../../../../css/2-modules/_forms.scss']
})
export class RegisterValuerComponent implements OnInit {
  loading: boolean = false;
  emailPattern = GlobalConstants.emailPattern;
  passwordPattern = GlobalConstants.passwordPattern;

  form: RegisterUserVm = {
    personalDetails: {
      alternativeNumber: '',
      emailAddress: '',
      emailConfirmed: false,
      id_Number: '',
      name: '',
      phoneNumber: '',
      surname: '',
      rsa_Resident: false,
      phoneNumberConfirmed: false,
      landline: '',
      title: '',
      confirmEmail: '',
      confirmPhoneNumber: ''
    },
    loginDetails: {
      email: '',
      password: '',
      passwordConfirm: '',
    }
  }

  constructor(private router: Router, private authService: AuthenticateService, private sharedService: PropertyMatrixSharedService) { }

  register() {
    this.loading = true;
    this.authService.apiV1AuthenticateRegisterValuerPost$Response({ body: this.form })
      .subscribe({
        next: (result) => {
          if (result.status == HttpStatusCode.Conflict) {
            GlobalMethods.tinyErrorAlert('Error', 'User already exists');
            return;
          }
          GlobalMethods.tinySuccessAlert('Welcome', 'Please login. After signing in, you will be redirected the valuer info page.').then(result => {
            GlobalMethods.navigateToLoginWithRouteStored('originalUrl', '/valuerSteps', this.router)
          });
          this.loading = false;
        }
        , error: (error) => {
          GlobalMethods.tinyErrorAlert('Error', 'User already exists')
          this.loading = false;
        }
      })
  }

  ngOnInit(): void {
    const user = this.sharedService.getUserModel();
    if (user) {
      this.router.navigateByUrl('/valuer-steps')
    }
  }
}